
import type { PropType } from 'vue'
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'EpbList',
  props: {
    items: Array as PropType<unknown[]>,
    default: () => [],
  },
  setup() {
    const baseClass = 'epb-list'
    return {
      baseClass,
    }
  },
})
